import { SVGProps } from "react";

const KpiClockIcon = ({
  width = 20,
  height = 20,
  color = "#854DDF",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 0C4.26 0 0 4.26 0 9.5C0 14.74 4.26 19 9.5 19C14.74 19 19 14.74 19 9.5C19 4.26 14.74 0 9.5 0ZM13.56 13.56C13.4 13.72 13.16 13.82 12.94 13.82C12.72 13.82 12.5 13.74 12.34 13.56L8.88 10.12C8.72 9.96 8.62 9.74 8.62 9.5V4.32C8.62 3.84 9 3.46 9.48 3.46C9.96 3.46 10.34 3.84 10.34 4.32V9.14L13.54 12.34C13.9 12.68 13.9 13.22 13.56 13.56Z"
      fill={color}
    />
  </svg>
);

export default KpiClockIcon;
